import { ExportPreference } from './export-preference';
import { DeliveryListPreference } from './delivery-list.preference';
import { ConnectionListFilters } from './connection-list-filters';
import { ReportsPreference } from './reports.preference';

export class UserCompanyPreference {
    id: string;
    name: string;
    avatar_url: string;
    locationId: string;
    previousLocationId: string;
    isMultiLocation: boolean;
    isDeliveryOrdersSeen: boolean;
    unitMeasurement: string;
    orderList: DeliveryListPreference;
    connectionList: ConnectionListFilters;
    export: ExportPreference;
    reports: ReportsPreference;
    trialExpiredReminder: boolean;
}
